import { UserInterfaceIdiomProvider } from '@psl/appComponents/UserInterfaceIdiomContext';
import { NavigatorScreenParams } from '@react-navigation/native';
import { lazy } from 'react';
import {
  adaptiveWrapperOptions,
  ModalWrapper,
} from '../../appComponents/ModalWrapper';
import { useIsMobileLayout } from '../../components/styles/responsive';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import { GoLiveFlowScreensParams } from './components/GoLiveFlowContent';

const GoLiveFlowContent = lazy(() => import('./components/GoLiveFlowContent'));

const GoLiveFlow = wrapLazyNavigatorScreen(
  (_: NavigatorScreenParams<GoLiveFlowScreensParams> | {}) => {
    const isMobileLayout = useIsMobileLayout();

    if (isMobileLayout) {
      return (
        <UserInterfaceIdiomProvider name="golive" userInterfaceStyle="light">
          <GoLiveFlowContent />
        </UserInterfaceIdiomProvider>
      );
    }

    return (
      <UserInterfaceIdiomProvider name="golive" userInterfaceStyle="light">
        <ModalWrapper>
          <GoLiveFlowContent />
        </ModalWrapper>
      </UserInterfaceIdiomProvider>
    );
  },
  adaptiveWrapperOptions(),
);

export default GoLiveFlow;
